// locations.js

import Locations from '../components/locations.svelte'

const { $ } = window//.jQuery

export default {
	init() {
		//let $locationsWrap = $('#locations_wrap')
		//console.log(dealersData)
		let $locationsWrap = document.querySelector('#locations_wrap')
		if ($locationsWrap) {
			new Locations({
				target: $locationsWrap,
				//props: JSON.stringify(dealersData), //$locationsWrap.data(),
			})
		}
	},
	finalize() {
	},
}
